import { Link } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import { useSelector } from "react-redux";
import ActionsMenu from "../../../shared/components/ActionsMenu";
import { getActions } from "./actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function EntityTable({
    id,
    currPage,
    onEdit,
    onPageChange,
    onFusion
}) {
    const user = JSON.parse(localStorage.getItem('user'));
    const clientes = useSelector(state =>  state.clientes);
 
    const handleChangePage = (event, newPage) => { onPageChange(newPage); }

    const getPaginationCount = () => {
      var totalPages = clientes?.total_items < 15 ? 1 : Math.ceil(clientes?.total_items / 15);
      return totalPages ? parseInt(totalPages) : 0;
    }

    const handleAction = (action, cliente) => {
        if(action === 'edit') {
            onEdit(cliente);
        } else  if(action === 'fusion') {
            onFusion(cliente)
        }
    }

    return (
        <div className="w-100 d-flex flex-column align-items-end">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>nombre</th>
                            <th>CIF</th>
                            <th>teléfono</th>
                            <th>email</th>
                            <th className="text-center">tipo</th>
                            <th>población</th>
                            <th className="text-center">país</th>
                            <th className="text-center">credito</th>
                            <th className="text-center"></th>
                        </tr>
                    </thead>

                    <tbody>
                        { clientes.clientes?.map((cliente) => {
                            return (
                                <tr key={cliente.id}>
                                    <td width="5%">{cliente.id}</td>
                                    <td width="15%">
                                        <Link target="_blank" rel="noopener noreferrer" to={`/cliente/${cliente.id}`} title="Ficha Cliente" className="text-green text-uppercase">
                                            {cliente.nombre}
                                        </Link> 
                                    </td>
                                    <td width="6%">{cliente.cif}</td>
                                    <td width="12%">{cliente.telefono}</td>
                                    <td width="12%">{cliente.email}</td>
                                    <td className="text-center text-uppercase" width="8%">{cliente.tipo_cliente_id ? cliente.tipo_cliente.nombre : ''}</td>
                                    <td width="12%" className="text-uppercase">{(cliente.codigo_postal_facturacion + " " + cliente.poblacion_facturacion)}</td>
                                    <td className="text-center text-uppercase" width="6%">{cliente.pais_facturacion_id ? cliente.pais_facturacion.nombre : ''}</td>
                                    <td className="text-center" width="6%">{cliente.credito ? <FontAwesomeIcon icon={faCheck} size="1x" className="action" color="#00986C" /> : <FontAwesomeIcon icon={faTimes} size="1x" className="action" color="#dc3545" />}</td>
                                    <td width={'5%'} className="text-center">
                                        <ActionsMenu 
                                            options={getActions(user)}
                                            onAction={(action) => handleAction(action, cliente)}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            

            <Pagination 
                id={id}
                className="mt-3" 
                count={getPaginationCount()} 
                page={currPage}
                onChange={handleChangePage} 
            />
        </div>
    )
}